import React, { useRef } from 'react';
import { useWindowSize } from 'usehooks-ts';
import {
  Typography,
  Dialog,
  AppBar,
  Toolbar,
  IconButton,
  Stack
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

interface FileDisplayDialogProps {
  dialogOpen: boolean;
  dialogClose: () => void;
  fileName: string;
  fileUrl: string;
  actionButton?: React.ReactNode;
}

export default ({
  dialogOpen,
  dialogClose,
  fileName,
  fileUrl,
  actionButton
}: FileDisplayDialogProps) => {
  const { height } = useWindowSize();

  const appBarRef = useRef<HTMLDivElement>(null);

  return (
    <Dialog
      open={dialogOpen}
      onClose={dialogClose}
      fullScreen
      sx={{
        msOverflowStyle: 'none',
        overflow: 'auto'
      }}
    >
      <AppBar ref={appBarRef} sx={{ position: 'relative', width: 'auto' }}>
        <Toolbar sx={{ width: 'auto' }}>
          <IconButton
            edge="start"
            color="inherit"
            onClick={dialogClose}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>
          <Typography
            variant="h1"
            component="h1"
            gutterBottom
            sx={{
              paddingLeft: '20px',
              paddingTop: '5px',
              color: 'white',
              ml: 2,
              flex: 1
            }}
          >
            {fileName}
          </Typography>
          {actionButton ?? null}
        </Toolbar>
      </AppBar>
      <Stack
        sx={{
          width: '100%',
          height: `${height - (appBarRef?.current?.offsetHeight || 64)}px`
        }}
      >
        <iframe
          id="fileViewerIframe"
          src={fileUrl}
          width="100%"
          height={height - (appBarRef?.current?.offsetHeight || 64)}
          marginHeight={0}
          marginWidth={0}
          frameBorder={0}
        ></iframe>
      </Stack>
    </Dialog>
  );
};
